export const links = {
  connect: {
    root: '/',
  },
  dashboard: {
    root: '/dashboard',
    rewards: '/dashboard/rewards',
  },
  referrals: '/referrals',
  operator: {
    root: '/admin',
  },
}
